module.exports = __webpack_public_path__ + "static/img/18.7b96895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/18.png
// module id = rXQe
// module chunks = 35